module.exports = __webpack_public_path__ + "img/download.89a79a13.png";